import React from 'react';

interface LoRaIconProps {
  className?: string;
  size?: number;
  color?: string;
}

export const LoRaIcon: React.FC<LoRaIconProps> = ({ 
  className = '', 
  size = 24, 
  color = '#57C5D6' 
}) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M7.3 14.7l1.2-1.2c-1-1-1.5-2.3-1.5-3.5 0-1.3 0.5-2.6 1.5-3.5L7.3 5.3c-1.3 1.3-2 3-2 4.7s0.7 3.4 2 4.7z" 
        fill={color}
      />
      <path 
        d="M19.1 2.9l-1.2 1.2c1.6 1.6 2.4 3.8 2.4 5.9 0 2.1-0.8 4.3-2.4 5.9l1.2 1.2c2-2 2.9-4.5 2.9-7.1 0-2.6-1-5.1-2.9-7.1z" 
        fill={color}
      />
      <path 
        d="M6.1 4.1L4.9 2.9C3 4.9 2 7.4 2 10c0 2.6 1 5.1 2.9 7.1l1.2-1.2c-1.6-1.6-2.4-3.8-2.4-5.9 0-2.1 0.8-4.3 2.4-5.9z" 
        fill={color}
      />
      <path 
        d="M16.7 14.7c1.3-1.3 2-3 2-4.7-0.1-1.7-0.7-3.4-2-4.7l-1.2 1.2c1 1 1.5 2.3 1.5 3.5 0 1.3-0.5 2.6-1.5 3.5l1.2 1.2z" 
        fill={color}
      />
      <path 
        d="M14.5 10c0-1.38-1.12-2.5-2.5-2.5S9.5 8.62 9.5 10c0 0.76 0.34 1.42 0.87 1.88L7 22h2l0.67-2h4.67L15 22h2l-3.37-10.12c0.53-0.46 0.87-1.12 0.87-1.88zM10.33 18L12 13l1.67 5h-3.34z" 
        fill={color}
      />
    </svg>
  );
};

export default LoRaIcon;